<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-card color="grey-lighten-2">
          <v-card-title>Faixa promocional</v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="4" md="3">
                <v-switch
                          v-model="settings.enabled"
                          label="Faixa habilitada"
                          color="primary"
                          density="compact"
                          hide-details
                          :disabled="savingSettings"></v-switch>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                              v-model.number="settings.rotation_minutes"
                              type="number"
                              min="1"
                              max="1440"
                              label="Rotação (minutos)"
                              density="compact"
                              hide-details
                              :disabled="savingSettings"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-btn
                       color="primary"
                       :loading="savingSettings"
                       :disabled="savingSettings"
                       @click="saveSettings">
                  <v-icon class="mr-2">mdi-content-save</v-icon>
                  Salvar faixa
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-form @submit.prevent="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <v-btn
                     color="primary"
                     class="float-right"
                     density="compact"
                     @click="openCreate">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Novo banner
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Título"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()">
                  <v-icon class="mr-2">mdi-broom</v-icon>
                  Limpar pesquisa
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit">
                  <v-icon class="mr-2">mdi-magnify</v-icon>
                  Pesquisar
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>Banners promocionais</v-card-title>
          <v-data-table
                        :headers="headers"
                        :items="lstObjects"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.preview="{ item }">
              <v-img
                     :src="item.image_desktop || item.image_mobile"
                     max-height="40"
                     width="120"
                     cover></v-img>
            </template>
            <template v-slot:item.is_active="{ item }">
              <span>{{ item.is_active ? 'Sim' : 'Não' }}</span>
            </template>
            <template v-slot:item.link_url="{ item }">
              <span>{{ item.link_url || '—' }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editObject(item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="toggleObject(item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-toggle-switch</v-icon>
                      {{ item.is_active ? 'Desativar' : 'Ativar' }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteObject(item)">
                    <v-list-item-title>
                      <v-icon color="red" class="mr-2">mdi-delete</v-icon>
                      Excluir
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogForm" max-width="640" scrollable>
      <v-card>
        <v-toolbar color="primary" :title="form.id ? 'Editar banner' : 'Novo banner'">
          <v-btn color="black" @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field
                        v-model="form.title"
                        label="Título"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-text-field
                        v-model="form.link_url"
                        label="Link (URL)"
                        density="compact"
                        class="mb-2"></v-text-field>
          <p class="text-caption mb-1">Imagem desktop (1920×320)</p>
          <input type="file" accept="image/*" @change="onDesktopFile" />
          <v-img
                 v-if="form.image_desktop_url && !form.image_desktop"
                 :src="form.image_desktop_url"
                 max-height="80"
                 class="my-2"></v-img>
          <p class="text-caption mt-4 mb-1">Imagem mobile (1080×360)</p>
          <input type="file" accept="image/*" @change="onMobileFile" />
          <v-img
                 v-if="form.image_mobile_url && !form.image_mobile"
                 :src="form.image_mobile_url"
                 max-height="80"
                 class="my-2"></v-img>
          <v-switch
                    v-model="form.is_active"
                    label="Ativo"
                    color="primary"
                    density="compact"
                    hide-details
                    class="mt-4"></v-switch>
          <v-text-field
                        v-model.number="form.sort_order"
                        type="number"
                        min="0"
                        max="9999"
                        label="Ordem"
                        density="compact"
                        class="mt-2"></v-text-field>
          <v-text-field
                        v-model="form.starts_at"
                        type="date"
                        label="Início"
                        density="compact"></v-text-field>
          <v-text-field
                        v-model="form.ends_at"
                        type="date"
                        label="Fim"
                        density="compact"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn
                 color="success"
                 :loading="requestingApi"
                 :disabled="requestingApi"
                 @click="submitForm">
            <v-icon class="mr-2">mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import api from '@/services'

function dateOnly(value) {
  if (!value) return ''
  return String(value).substring(0, 10)
}

function emptyForm() {
  return {
    id: null,
    title: '',
    link_url: '',
    is_active: false,
    sort_order: 0,
    starts_at: '',
    ends_at: '',
    image_desktop: null,
    image_mobile: null,
    image_desktop_url: '',
    image_mobile_url: '',
  }
}

export default {
  name: 'PromoBanners',
  setup() {
    return { api }
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      savingSettings: false,
      headers: [
        { title: 'Preview', key: 'preview', sortable: false },
        { title: 'Título', align: 'start', key: 'title', sortable: true },
        { title: 'Ativo', key: 'is_active', sortable: true },
        { title: 'Ordem', key: 'sort_order', sortable: true },
        { title: 'Link', key: 'link_url', sortable: false },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      lstObjects: [],
      filters: {
        searchText: null,
        itemsPerPage: 10,
      },
      settings: {
        enabled: true,
        rotation_minutes: 5,
      },
      page: 1,
      maxPage: 1,
      dialogForm: false,
      form: emptyForm(),
    }
  },
  created() {
    this.loadParameters()
    this.loadSettings()
    this.submitSearch(1)
  },
  methods: {
    loadParameters() {
      const stored = localStorage['_promo_banners_itemsPerPage']
      this.filters.itemsPerPage = parseInt(stored || 10)
    },
    clearFilters() {
      this.filters.searchText = null
    },
    listPayload() {
      return { ...this.filters }
    },
    applyListResult(result) {
      const rows = result?.data
      if (Array.isArray(rows)) {
        this.lstObjects = rows
        this.maxPage = 1
      } else {
        this.lstObjects = rows?.data || []
        this.maxPage = Math.ceil((rows?.total || 1) / (rows?.per_page || this.filters.itemsPerPage || 10))
      }
      if (result?.settings) {
        this.settings = {
          enabled: !!result.settings.enabled,
          rotation_minutes: result.settings.rotation_minutes || 5,
        }
      }
    },
    submitSearch(page) {
      if (this.requestingApi) return
      const nextPage = Number.isFinite(page) ? page : 1
      this.requestingApi = true
      this.page = nextPage
      return api.promoBanner
        .list(this.listPayload(), this.page)
        .then((result) => {
          this.applyListResult(result)
          this.$notify({ type: 'success', text: 'Pesquisa concluída' })
        })
        .catch((err) => {
          if (err?.message) {
            this.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          this.requestingApi = false
        })
    },
    loadSettings() {
      return api.promoBanner
        .getSettings()
        .then((result) => {
          if (result) {
            this.settings = {
              enabled: !!result.enabled,
              rotation_minutes: result.rotation_minutes || 5,
            }
          }
        })
        .catch(() => {})
    },
    saveSettings() {
      if (this.savingSettings) return
      const minutes = Math.max(1, Math.min(1440, Number(this.settings.rotation_minutes) || 1))
      this.settings.rotation_minutes = minutes
      this.savingSettings = true
      return api.promoBanner
        .updateSettings({
          enabled: !!this.settings.enabled,
          rotation_minutes: minutes,
        })
        .then((result) => {
          if (result) {
            this.settings = {
              enabled: !!result.enabled,
              rotation_minutes: result.rotation_minutes || minutes,
            }
          }
          this.$notify({ type: 'success', text: 'Faixa atualizada' })
        })
        .catch((err) => {
          if (err?.message) {
            this.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          this.savingSettings = false
        })
    },
    openCreate() {
      this.form = emptyForm()
      this.dialogForm = true
    },
    editObject(item) {
      this.form = {
        id: item.id,
        title: item.title || '',
        link_url: item.link_url || '',
        is_active: !!item.is_active,
        sort_order: item.sort_order || 0,
        starts_at: dateOnly(item.starts_at),
        ends_at: dateOnly(item.ends_at),
        image_desktop: null,
        image_mobile: null,
        image_desktop_url: item.image_desktop || '',
        image_mobile_url: item.image_mobile || '',
      }
      this.dialogForm = true
    },
    closeDialog() {
      this.dialogForm = false
      this.form = emptyForm()
    },
    onDesktopFile(event) {
      this.form.image_desktop = event?.target?.files?.[0] || null
    },
    onMobileFile(event) {
      this.form.image_mobile = event?.target?.files?.[0] || null
    },
    submitForm() {
      if (this.requestingApi) return
      const hasExistingImage = !!(this.form.image_desktop_url || this.form.image_mobile_url)
      const hasNewImage = !!(this.form.image_desktop || this.form.image_mobile)
      if (!this.form.id && !hasNewImage) {
        this.$notify({ type: 'warn', text: 'Envie ao menos a imagem desktop ou mobile' })
        return
      }
      if (this.form.id && !hasExistingImage && !hasNewImage) {
        this.$notify({ type: 'warn', text: 'Envie ao menos a imagem desktop ou mobile' })
        return
      }
      const fd = new FormData()
      if (this.form.id) fd.append('id', this.form.id)
      fd.append('title', this.form.title || '')
      fd.append('link_url', this.form.link_url || '')
      fd.append('is_active', this.form.is_active ? '1' : '0')
      fd.append('sort_order', this.form.sort_order ?? 0)
      fd.append('starts_at', this.form.starts_at || '')
      fd.append('ends_at', this.form.ends_at || '')
      if (this.form.image_desktop) fd.append('image_desktop', this.form.image_desktop)
      if (this.form.image_mobile) fd.append('image_mobile', this.form.image_mobile)
      this.requestingApi = true
      return api.promoBanner
        .updateOrCreate(fd)
        .then((result) => {
          if (result?.id) {
            const ix = this.lstObjects.findIndex((x) => x.id === result.id)
            if (ix >= 0) {
              this.lstObjects.splice(ix, 1, { ...this.lstObjects[ix], ...result })
            } else {
              this.lstObjects.unshift(result)
            }
          }
          this.$notify({ type: 'success', text: 'Banner salvo' })
          this.closeDialog()
        })
        .catch((err) => {
          if (err?.message) {
            this.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          this.requestingApi = false
        })
    },
    toggleObject(item) {
      if (this.requestingApi || !item?.id) return
      this.requestingApi = true
      return api.promoBanner
        .toggle(item.id)
        .then((result) => {
          const ix = this.lstObjects.findIndex((x) => x.id === item.id)
          if (ix >= 0) {
            this.lstObjects.splice(ix, 1, {
              ...this.lstObjects[ix],
              ...(result || {}),
              is_active: result?.is_active ?? !item.is_active,
            })
          }
          this.$notify({ type: 'success', text: 'Banner atualizado' })
        })
        .catch((err) => {
          if (err?.message) {
            this.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          this.requestingApi = false
        })
    },
    deleteObject(item) {
      if (!item?.id) return
      const confirmed = confirm('Deseja realmente excluir este banner?')
      if (!confirmed) return
      this.requestingApi = true
      return api.promoBanner
        .delete(item.id)
        .then(() => {
          const ix = this.lstObjects.findIndex((x) => x.id === item.id)
          if (ix >= 0) this.lstObjects.splice(ix, 1)
          this.$notify({ type: 'success', text: 'Removido com sucesso' })
        })
        .catch((err) => {
          if (err?.message) {
            this.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          this.requestingApi = false
        })
    },
  },
  watch: {
    'filters.itemsPerPage'(newVal) {
      localStorage['_promo_banners_itemsPerPage'] = newVal
    },
    page(newVal) {
      if (!isNaN(newVal)) {
        this.submitSearch(newVal)
      }
    },
  },
}
</script>
